import React, { useEffect, useState } from 'react';
import logoSrc from '../assets/logos/SQlogo.png';

const SPLASH_DURATION_MS = 2200;

const SquareNowSplash = () => {
	const [visible, setVisible] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setVisible(false);
		}, SPLASH_DURATION_MS);
		return () => clearTimeout(timer);
	}, []);

	if (!visible) return null;

	return (
		<div className='squarenow-splash' aria-hidden>
			<div className='squarenow-splash__inner'>
				<div className='squarenow-splash__logo-wrap'>
					<img
						src={logoSrc}
						alt='Square Now'
						className='squarenow-splash__logo'
					/>
				</div>
			</div>
		</div>
	);
};

export default SquareNowSplash;
